// src/hooks/useAppConfig.js
import { computed,ref } from 'vue';

export default function useAppConfig() {
  const config = computed(() => window.__APP_CONFIG__ || {});

  const isJJW = computed(() => config.value.appType === 'jijian');
  const isBFZS = computed(() => config.value.appType === 'caipianos');
  const isProd = computed(() => config.value.env === 'production');
  const isTest = computed(() => config.value.env === 'test');

  return {
    config,
    isJJW,
    isBFZS,
    isProd,
    isTest
  };
}